import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useChunkTranslation } from "../hooks/useChunkTranslation.js";
const SuspenseChunkTranslation = ({ children, chunkFile, fallback, options })=>{
    const done = useChunkTranslation(chunkFile, options());
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: done ? children : fallback
    });
};
export { SuspenseChunkTranslation };
